export { EventDetails } from './event-details';
export { MobileDetails } from './mobile-details';
